export default {
    en: {
        title: 'Expenses',
        name: 'Name',
        date: 'Date',
        total: 'Amount',
        type: 'Payment Type',
        actions: 'Actions',
        newBtn: 'Create Expense',
        payment: {
            cash: 'Cash',
            card: 'Card',
            bank: 'Bank',
        },
        newItem: {
            title: "Add Expense",
            name: "Name",
            namePlaceholder: "For Rent",
            amount: "Amount",
            type: "Expense Type",
            btn: 'Create',
            note: 'Note'
        },
        edit: {
            title: "Edit Expense",
            name: "Name",
            namePlaceholder: "For Rent",
            amount: "Amount",
            type: "Expense Type",
            btn: 'Update'
        }
    },
    uz: {
        title: 'Xarajatlar',
        name: 'Nomi',
        date: 'Sana',
        total: 'Qiymati',
        type: "To'lov turi",
        actions: 'Vazifalar',
        newBtn: 'Yangi Xarajat',
        payment: {
            cash: 'Naqt',
            card: 'Karta',
            bank: 'Bank',
        },
        newItem: {
            title: "Xarajatlarga qo'shish",
            name: "Xarajat Nomi",
            namePlaceholder: "Ijara uchun",
            amount: "Qiymati",
            type: "To'lov turi",
            btn: 'Yaratish',
            note: "Qo'shimcha ma'lumot"
        },
        edit: {
            title: "Xarajatni yangilash",
            name: "Xarajat Nomi",
            amount: "Qiymati",
            type: "To'lov turi",
            btn: 'Yangilash'
        }
    },
    ru: {
        title: 'Расходы',
        name: 'Название',
        date: 'Дата',
        total: 'Сумма',
        type: 'Тип оплаты',
        actions: 'Задачи',
        newBtn: 'Создать Расход',
        payment: {
            cash: 'Наличные',
            card: 'Карта',
            bank: 'Банк',
        },
        newItem: {
            title: "Добавить расходы",
            name: "Название",
            namePlaceholder: "За аренду",
            amount: "Сумма",
            type: "Тип оплаты",
            btn: 'Создать',
            note: 'Описание'
        },
        edit: {
            title: "Изменить расходы",
            name: "Название",
            namePlaceholder: "За аренду",
            amount: "Сумма",
            type: "Тип оплаты",
            btn: 'Сохранить'
        }
    }
}